import React, { Component } from 'react';
import {  Rate,Tooltip,Button,message,Tag,Modal} from 'antd';
import {connect} from 'react-redux';
/** Personal */
import {TYPE_MAP,TYPE_MAP_VIEW,WELL_CHOSEN_MAP} from '../../../utils/questionType';
import {ONLINESTATUS} from '../../../utils/questionManageType';
import WEB_API from '@/API/api';
import axios from 'axios'

const CHECKSTATUS = {
    0 :'未检测',
    1 :'验证通过',
    2 :'验证未通过',
    3 :'不支持'
}
const confirm=Modal.confirm
class Footer extends Component {
    timer = null; // 修改分数定时器
    state={
        showFooterInfo:false,
        toggleBtnName: false
    }
    // 修改分数事件
    handleChange = (value) => {
        const { handleChange, obj } = this.props;
        if (value == obj.score) {
            return;
        }
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            handleChange && handleChange(value);
        }, 500);
    };
    toggleAnswer = (val, e) => {
        // val && cnzz.statistics('PC端作业详情页', 2, '展开答案'); /** 打点统计 */
        e.stopPropagation();
        this.setState({showFooterInfo: val});
    };
    // 切换关联关系
    toggleRelative = () => {
        let { toggleBtnName } = this.state;
        this.setState({toggleBtnName : !toggleBtnName})
    }
    
    render() {
        const {
            children,
            showRelative
        } = this.props;
        const { toggleBtnName } = this.state;
        const relative_leg = this.props.obj&&this.props.obj.relate_info&&this.props.obj.relate_info.length||''
        return <div>
            <div style={{ position: 'relative',float: 'right',width: '230px' }}>
                {children}
                {
                    !!showRelative ? <Button className="relative-btn" onClick={this.toggleRelative}>{toggleBtnName ? `隐藏关联关系(${relative_leg})` : `显示关联关系(${relative_leg})`}</Button> : null
                }
                {
                    this.props.canShowFooterInfo ?
                        <button style={    {transform: 'translateY(-40px)'} }
                            className="question-btn"
                            onClick={(e) => this.toggleAnswer(!this.state.showFooterInfo,e)}>
                            {!this.state.showFooterInfo ? '显示' : '隐藏'}
                        </button> : null

                }
            </div>
            <FooterBottom {...this.props} toggleBtnName={toggleBtnName}  showFooterInfo={this.props.defaultHideFooterInfo&&!(this.state.showFooterInfo)} />
        </div>
    }
}
const onlineStatusMap={
    0:{text:'未上线',color:'gray'},
    1:{text:'上线中',color:'orange'},
    2:{text:'已上线',color:'green'}
}
class FooterBottom extends Component {
    
    // 跳转对应关联关系
    handleRelative = (item, question_id) => {
        const type = item.type;
        const data = item.data;
        let casData = []; // 版本 课本 教辅
        let lastValue = []; // 三级筛选项的最后一项
        data.forEach((item, index) => {
            if (index < 3) {
                casData.push(item.id)
            }
            if (index === data.length -1) {
                lastValue.push(item.id)
            }
        });
        if (!item.is_all) {
            message.error('没有绑定版本');
            return false;
        }
        window.open(encodeURI(`${window.location.origin}#/questionmanage/lookoverquestion?type=${type}&casDate=${casData.join(',')}&lastValue=${lastValue.join(',')}&questionId=${question_id}`))
    }

    onLineRelation=(item,question_id)=>{
        if(item.online_status!=1){
            const _this=this
            const confirmText=item.online_status==0?'上线':'下线'
            const url=item.online_status==0?WEB_API.BATCH_ONLINE_RELATION:WEB_API.BATCH_OFFLINE_RELATION
            const section_id=item.data[item.data.length-1].id
            confirm({
                title: '提示',
                content: `此操作将${confirmText}当前关联关系，确定${confirmText}吗？`,
                onOk() {
                    axios.post(url, {section_id,question_id}).then((res)=>{
                        res = res.data;
                        if (res.code === 0) {
                            message.success(`${confirmText}关联关系成功！`);
                        }else{
                            message.error(res.message);
                        }
                    },()=>{message.error("操作失败！")})
                },
                onCancel() {},
            });
        }
        
    }

    render() {
        const {
            obj,
            subject,
            product,
            toggleBtnName
        } = this.props;
        const { relate_info } = obj;
        
        
        if(this.props.showFooterInfo){return null}

        return <div style={{paddingRight: 230}}>
            {
                obj.id && <span style={{fontSize: 14, marginRight: 30}}>题目ID: {obj.id}</span>
            }



            {
                obj.local && <span style={{fontSize: 14, marginRight: 30}}>本地正确率: {obj.local}</span>
            }
            {
                obj.right && <span style={{fontSize: 14, marginRight: 30}}>本地正确率: {obj.right}</span>
            }
            {
                obj.type_show && <span style={{fontSize: 14, marginRight: 30}}>题目类型：{TYPE_MAP[obj.type_show]}</span>
            }
            {
                obj.display_type && <span style={{fontSize: 14, marginRight: 30}}>展示题型：{TYPE_MAP_VIEW[obj.display_type]}</span>
            }
            {
                subject!=='0'&&product!=8&&product!=9&&(obj.well_chosen||obj.well_chosen===0) &&<span style={{fontSize: 14, marginRight: 30}}>题包类型：{WELL_CHOSEN_MAP[obj.well_chosen]}</span>
            }
            {
                !!obj.online_status && <span style={{fontSize: 14, marginRight: 30}}>题目状态：{ONLINESTATUS[obj.online_status]}</span>
            }
            {
                !location.hash.includes('questionbox')&&<span style={{fontSize: 14, marginRight: 30}}>客户端审核：{CHECKSTATUS[~~(obj.u3d_check_status)]}</span>
            }
            {
                !location.hash.includes('questionbox')&&<span style={{fontSize: 14, marginRight: 30}}>小程序审核：{CHECKSTATUS[~~(obj.wxapp_check_status)]}</span>
            }
            {
                !!obj.relate_online_status && <span style={{fontSize: 14, marginRight: 30}}>关联关系状态：{ONLINESTATUS[obj.relate_online_status]}</span>
            }
            {
                !!obj.difficulty && <span style={{fontSize: 14, marginRight: 30}}>
                                难易度: <Rate count={4} value={parseInt(obj.difficulty)} disabled
                                           style={{fontSize: 14, lineHeight: "17px", verticalAlign: 'text-bottom'}}/>
                            </span>
            }
            {
                obj.train && <span style={{fontSize: 14, marginRight: 30}}>练习量: {obj.train}</span>
            }
            {
                (obj.rate || obj.rate == 0) && <span style={{fontSize: 14, marginRight: 30}}>全国正确率: {obj.rate == '-1' ? '0' : obj.rate}%{(obj.total_times||obj.total_times===0)?`(${obj.total_times})`:''}</span>
            }
            {
                (+subject === 0 && !!obj.isChapter && (obj.edition_right_rate || obj.edition_right_rate == 0)) && <span style={{fontSize: 14, marginRight: 30}}>版本正确率: {obj.edition_right_rate == '-1' ? '0' : obj.edition_right_rate}%{(obj.edition_total_times||obj.edition_total_times===0)?`(${obj.edition_total_times})`:''}</span>
            }
            {
                (+subject === 0 && !!obj.isChapter && (obj.grade_right_rate || obj.grade_right_rate == 0)) && <span style={{fontSize: 14, marginRight: 30}}>年级正确率: {obj.grade_right_rate == '-1' ? '0' : obj.grade_right_rate}%{(obj.grade_total_times||obj.grade_total_times===0)?`(${obj.grade_total_times})`:''}</span>
            }
            {
                (+subject === 0 && (obj.fix_click_rate || obj.fix_click_rate == 0)) && <span style={{fontSize: 14, marginRight: 30}}>布置浏览比: {obj.fix_click_rate}({obj.click_times})</span>
            }
            {
                (+subject === 0  && (obj.save_rate || obj.save_rate == 0)) && <span style={{fontSize: 14, marginRight: 30}}>留题率: {obj.save_rate}({obj.click_times})</span>
            }
            
            
            {
                (obj.question_id_origin>0) && <span style={{fontSize: 14, marginRight: 30}}>原题ID: {obj.question_id_origin}</span>
            }
            {
                (obj.know_list && obj.know_list.length>0) && <div><span style={{fontSize: 14}}>知识点: {obj.know_list.concat().map((d,i)=><Tooltip key={d.id||i} title={d.id} mouseEnterDelay={1}><span style={{marginLeft:8}}>{d.name}{'  '}</span></Tooltip>)}</span></div>
            }
            {
                (obj.issue_list && obj.issue_list.length>0) && <div><span style={{fontSize: 14}}>考点: {obj.issue_list.concat().map((d,i)=><Tooltip key={d.id||i} title={d.id} mouseEnterDelay={1}><span style={{marginLeft:8}}>{d.name}{'  '}</span></Tooltip>)}</span></div>
            }
            {
                (obj.ability_list && obj.ability_list.length>0) && <div><span style={{fontSize: 14}}>能力: {obj.ability_list.concat().map((d,i)=><Tooltip key={d.id||i} title={d.id} mouseEnterDelay={1}><span style={{marginLeft:8}}>{d.name}{'  '}</span></Tooltip>)}</span></div>
            }
            {
                (obj.cateitem_list && obj.cateitem_list.length>0)&&
                obj.cateitem_list.map((d,i)=>
                    <div key={i}><span style={{fontSize: 14}}>{d.name}: {d.list.join(', ')}</span></div>
                )
            }
            {   
                !!toggleBtnName ?
                <div className="relative-list" style={{marginRight: '-230px', fontSize: '14px'}}>
                {
                    relate_info && obj.relate_info.map((item, index) => 
                        <dl className="clearfix" key={index}>
                            <dt onClick={() => this.handleRelative(item, obj.question_id)}>{`关联关系${index+1}`}</dt>
                            {
                                item.data && item.data.length > 0 && item.data.map(innerItem => 
                                    <dd key={innerItem.id}>{innerItem.name}</dd>
                                ) 
                            } 
                            <Tag  onClick={()=>this.onLineRelation(item,obj.question_id)} color={onlineStatusMap[item.online_status].color}>{onlineStatusMap[item.online_status].text}</Tag>  
                        </dl>
                    )
                }
                </div> : null
            }

        </div>
    }
}

const mapStateTopProps = (state) => {
    return {
        product:state.user.product,
    };
}
const mapDispatchToProps = dispatch => {
    return {

    }
};


export default connect (mapStateTopProps,mapDispatchToProps)(Footer)


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/Footer.js